import React, { useState } from 'react';
import { CSVLink } from 'react-csv';

export default function DownloadProfile({ institutionData }) {

    let headers = [];

    // data has three rows, so setup the structure
    let data = [{}];

    for (const [key, value] of Object.entries(institutionData.post_meta)) {

        // Skip certain keys that are not needed in the CSV
        if ([
            'aliases',
            'history',
            'institution-tab-notes',
            'research-tab-notes',
            'sae-tab-notes'
        ].indexOf(key) !== -1) continue;

        headers.push({
            label: key,
            key: key
        });
        data[0][key] = value.label || '';
    }

    // Append Scorecard data to the CSV
    const scorecard = institutionData.scorecard;
    headers.push({ 'label': 'Net Price', key: 'net_price' });
    data[0]['net_price'] = scorecard?.net_price?.value || '';

    headers.push({ 'label': 'Median Debt', key: 'average_debt' });
    data[0]['average_debt'] = scorecard?.debt?.average_debt || '';

    headers.push({ 'label': 'Received Loans', key: 'received_loans' });
    data[0]['received_loans'] = scorecard?.debt?.received_loans || '';

    headers.push({ 'label': 'Outcomes 8 Years: Students', key: 'students' });

    data[0]['students'] = scorecard?.outcomes?.cohort?.full_time?.first_time?.['8yr_pooled'] +
        scorecard?.outcomes?.cohort?.full_time?.not_first_time?.['8yr_pooled'] +
        scorecard?.outcomes?.cohort?.part_time?.first_time?.['8yr_pooled'] +
        scorecard?.outcomes?.cohort?.part_time?.not_first_time?.['8yr_pooled'];


    headers.push({ 'label': 'Outcomes 8 Years: Graduated', key: 'graduated' });
    data[0]['graduated'] = scorecard?.outcomes?.data['8yr']?.award_pooled || '';

    headers.push({ 'label': 'Outcomes 8 Years: Transferred', key: 'transferred' });
    data[0]['transferred'] = scorecard?.outcomes?.data['8yr']?.transfer_pooled || ''

    headers.push({ 'label': 'Outcomes 8 Years: Withdrew', key: 'withdrew' });
    data[0]['withdrew'] = scorecard?.outcomes?.data['8yr']?.unknown_pooled || ''

    headers.push({ 'label': 'Outcomes 8 Years: Still Enrolled', key: 'still_enrolled' });
    data[0]['still_enrolled'] = scorecard?.outcomes?.data['8yr']?.still_enrolled_pooled || ''

    return (
        <div style={{ textAlign: 'right' }}>
            <CSVLink data={data} headers={headers} filename={`${institutionData.post.post_name}.csv`}>
                <img src="/wp-content/plugins/ace-carnegie-institution-charts/frontend/src/images/icon-download.svg"
                    alt="Download Icon" className="me-2" style={{ width: '20px', height: '20px' }} />
                Download CSV
            </CSVLink>
        </div>
    );
}